import React, { useCallback, useMemo } from 'react';
import styles from './MaterialModal.module.scss';
import Modal from '@components/modal/Modal';
import Button from '@components/button/Button';
import { SllLesson, SllModule } from '@src/types';
import { hasArrayValues } from '@src/utils/helpers';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { IconInfo } from '@src/constants';
import MaterialCard from '@src/components/materialCard/SllCard';

type Props = {
  open?: boolean;
  lesson: SllLesson;
  firstOpen?: boolean | false;
  startLesson?: () => void;
  handleShowMaterialPDF?: (url: string) => void;
  handlePrintMaterialPDF?: (url: string) => void;
};

function MaterialModal(props: Props) {
  const { open, lesson, firstOpen, startLesson, handleShowMaterialPDF, handlePrintMaterialPDF } = props;

  const requiredMaterials = useMemo(() => {
    if (!lesson?.materials) return [];
    return lesson?.materials.filter(material => (material?.isRequired === true && material.name.toLowerCase().includes('student')))
  }, [lesson?.materials])

  const optionalMaterials = useMemo(() => {
      if (!lesson?.materials) return [];
      return lesson?.materials.filter(material => (material?.isRequired === false && material.name.toLowerCase().includes('student')))
  }, [lesson?.materials])

  const handlePrintMaterial = useCallback((content: SllModule) => {
    if (content.data) {
      handlePrintMaterialPDF?.(content.data)  
    }
  }, [handlePrintMaterialPDF])

  const handleDownloadLessonMaterial = useCallback((content: SllModule) => {
    if (content.data) {
      handleShowMaterialPDF?.(content.data)  
    }
  }, [handleShowMaterialPDF])

  return (
    <Modal open={!!open} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <div className={styles.title}>{'Lesson Materials'}</div>
        <div className={styles.detail}>{'Please download the materials for this lesson.'}</div>
        <div className={styles.content}>
          <div className={styles.subView}>
            {hasArrayValues(requiredMaterials) && <div className={styles.materialContents}>
                <div className={styles.requireTitle}>
                    Required
                    <LordIcon src={IconInfo} isHover={true} colors={{primary: '#FFB073', secondary: '#FFB073'}} size={20}/>
                </div>
                <div className={styles.unitsDiv}>
                {requiredMaterials.map((material, index) => {
                    return (
                    <MaterialCard key={index} content={material as SllModule} handleDownloadMaterial={handleDownloadLessonMaterial} handlePrintMaterial={handlePrintMaterial}/>
                    )
                })}
                </div>
            </div>}
            {hasArrayValues(optionalMaterials) && <div className={styles.materialContents}>
                <div className={styles.optionTitle}>
                    Optional
                    <LordIcon src={IconInfo} isHover={true} colors={{primary: '#6C969A', secondary: '#6C969A'}} size={20}/>
                </div>
                <div className={styles.unitsDiv}>
                {optionalMaterials.map((material, index) => {
                    return (
                    <MaterialCard key={index} content={material as SllModule} handleDownloadMaterial={handleDownloadLessonMaterial} handlePrintMaterial={handlePrintMaterial}/>
                    )
                })}
                </div>
            </div>}
          </div>
          <div className={styles.action}>
            <Button size='small' className={styles.startButton} onClick={startLesson} label={firstOpen ? 'BEGIN LESSON' : 'RETURN TO LESSON'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default MaterialModal;
